import { render, staticRenderFns } from "./BookingWidget.vue?vue&type=template&id=0f6364d7&scoped=true&"
import script from "./BookingWidget.vue?vue&type=script&lang=js&"
export * from "./BookingWidget.vue?vue&type=script&lang=js&"
import style0 from "./BookingWidget.vue?vue&type=style&index=0&id=0f6364d7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6364d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VForm,VIcon,VMenu,VTextField})
